import { DSFlex } from '@/components/ds/Flex/Flex'
import { DSSpacer } from '@/components/ds/Spacer/Spacer'
import { DSText } from '@zoe/ds-web'
import { Trustpilot } from '@/components/shared/Trustpilot'
import React, { useEffect, useState } from 'react'
import { DSLinkButton } from '@/components/ds/LinkButton/LinkButton'
import { useCookies } from 'react-cookie'
import { buildZoeDataQueryStringMap, ZOE_UTM_COOKIES_WHITELIST } from '@/lib/utils/utmData'
import { decorateLinksWithQueryParameters } from '@/lib/utils/queryParams'

const defaultQuizLink = `${process.env.QUIZ_URL}`

interface QuizVariantCTAProps {
  checkoutCountry?: string
}

export const QuizCTA = ({ checkoutCountry }: QuizVariantCTAProps) => {
  const [utmCookies] = useCookies(ZOE_UTM_COOKIES_WHITELIST)
  const [quizLink, setQuizLink] = useState<string>()

  useEffect(() => {
    const pageUrl = window.location.href
    const utmData = buildZoeDataQueryStringMap(utmCookies)
    const quizLink = decorateLinksWithQueryParameters(defaultQuizLink, pageUrl, {
      ...utmData,
      country: checkoutCountry,
    })
    setQuizLink(quizLink)
  }, [checkoutCountry, utmCookies])

  return (
    <DSFlex direction="column" justifyContent="center">
      <DSText variant="fluid-paragraph-200">3 MIN QUIZ</DSText>
      <DSSpacer size={16} direction="vertical" />
      <DSText variant="fluid-heading-900">
        Tell us about you – and discover <em>what&apos;s possible</em> with ZOE.
      </DSText>
      <DSSpacer size={16} direction="vertical" />

      {quizLink && (
        <DSLinkButton variant="primary" colourScheme="default" size="large" width="auto" href={quizLink}>
          Start the quiz
        </DSLinkButton>
      )}
      <DSSpacer size={16} direction="vertical" />

      <Trustpilot oneLine={true} />
    </DSFlex>
  )
}
